import { fileTypes, maxFileSize } from '../config/file';

const dataValidations = (fields, errors) => {
  const validationByType = (key, value) => {
    switch (key) {
      case 'email': {
        const isValidMail = value.match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        );
        if (!isValidMail) {
          return 'Invalid email.';
        }
        break;
      }
      case 'emailVerification': {
        const email = fields.find(({ key }) => key === 'email').value;
        if (value !== email) {
          return 'Email verification does not match the given email address.';
        }
        break;
      }
      case 'message': {
        if (value.length > 256) {
          return 'Message can only contain 256 characters.';
        }
        break;
      }
      case 'file': {
        const { type, size } = value;
        const isValidFileType = fileTypes.includes(type.split('/')[1]);
        if (!isValidFileType) {
          return `File type must be ${fileTypes}`;
        } else if (size > 1024 ** 2 * maxFileSize) {
          return `File sizes must not exceed ${maxFileSize}MB.`;
        }
        break;
      }
    }
  };

  const params = {};
  const newFields = fields.map(field => {
    const { key, value, required } = field;
    let error = '';
    if (value) {
      error = validationByType(key, value) || '';
      params[key] = value;
    } else if (required) {
      error = errors.requiredField;
    }
    return { ...field, error };
  });

  return { newFields, params };
};

export default dataValidations;
